export const numberWithCommasDecimals = (number: number) => {
  return number
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export const numberToCurrency = (
  number: number | string,
  currency: string = 'AUD' as const,
  locale: string = 'en-GB' as const
) => {
  if (typeof number === 'string') {
    number = parseFloat(number);
  }
  let result = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);

  if (currency === 'AUD') {
    result = result.replace('A$', '$');
  }

  return result;
};
export const floatToCurrency = (
  number: number,
  currency: string = 'AUD' as const,
  locale: string = 'en-GB' as const
): string => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
};
export const removeTrailingZeros = (currencyString: string) => {
  return currencyString.replace(/\.00$/, '');
};

export const convertAmountToCents = (currency: string | number): number => {
  // Remove any non-numeric characters except the decimal point
  if (typeof currency === 'string') {
    const cleanedString = currency?.replace(/[^0-9.]/g, '');
    // Convert the cleaned string to a float
    const floatValue = parseFloat(cleanedString);
    // Multiply by 100 to get the integer representation in cents
    return Math.round(floatValue * 100);
  }
  return Math.round(currency * 100);
};

export const convertCentsToAmount = (cents: number): number => {
  if (isNaN(cents)) {
    throw new Error('Input must be a number');
  }
  return parseFloat((cents / 100).toFixed(2));
};
